/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'TRAINING_RECORDS_ON_CHEMICAL_USE_AND_HANDLING_AND_DISPOSAL_AND_',
              'APPROPRIATE_CONTAINERS_ARE_USED_FOR_DISPENSING_ALL_CHEMICALS',
              'WRITTEN_PROCEDURES_ARE_IN_PLACE_FOR_REPORTING_AND_RESPONDING_TO',
              'A_COMPLETE_SPILL_KIT_APPROPRIATE_FOR_THE_TYPES_AND_USE_OF_CHEMI',
              'CHEMICALS_ARE_NOT_DISPOSED_OF_IN_WASTE_BIN_CONTAINERS_WHICH_ARE',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_any_of_the_following_measures_in_place_to_the: valueSchema,
  },
}
